<template>
  <div class="s-setting-container no-border">
    <PromoTable
      :partnerSettings="partnerSettings"
      :currentCorporation="currentCorporation"
    />
  </div>
</template>

<script>
import PromoTable from '@shared/components/promo/PromoTable.vue';

export default {
  name: 'OffersSection',
  components: {
    PromoTable,
  },
  props: {
    partnerSettings: Object,
    currentCorporation: Object,
  },
};
</script>

<style lang="scss" scoped>
.s-setting-container {
  display: flex !important;
  flex-direction: column;
}
</style>
